const countries = [
  { code: "GBR", name: "United Kingdom" },
  { code: "AUT", name: "Austria" },
  { code: "BEL", name: "Belgium" },
  { code: "BGR", name: "Bulgaria" },
  { code: "HRV", name: "Croatia" },
  { code: "CYP", name: "Cyprus" },
  { code: "CZE", name: "Czech Republic" },
  { code: "DNK", name: "Denmark" },
  { code: "EST", name: "Estonia" },
  { code: "FIN", name: "Finland" },
  { code: "FRA", name: "France" },
  { code: "DEU", name: "Germany" },
  { code: "GIB", name: "Gibraltar" },
  { code: "GRC", name: "Greece" },
  { code: "HUN", name: "Hungary" },
  { code: "ITA", name: "Italy" },
  { code: "LVA", name: "Latvia" },
  { code: "LTU", name: "Lithuania" },
  { code: "LUX", name: "Luxembourg" },
  { code: "MLT", name: "Malta" },
  { code: "MCO", name: "Monaco" },
  { code: "NLD", name: "Netherlands" },
  { code: "NOR", name: "Norway" },
  { code: "POL", name: "Poland" },
  { code: "PRT", name: "Portugal" },
  { code: "IRL", name: "Republic of Ireland" },
  { code: "ROU", name: "Romania" },
  { code: "SVK", name: "Slovakia" },
  { code: "SVN", name: "Slovenia" },
  { code: "ESP", name: "Spain" },
  { code: "SWE", name: "Sweden" },
  { code: "CHE", name: "Switzerland" },
];

export default countries;

export const getCountryCodeByName = (countryName = "") => {
  const countryData =
    countries.find((country) => country.name === countryName) || {};
  return countryData.code;
};
